import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import LookbookPage from "@/pages/LookbookPage";
import ProductsPage from "@/pages/ProductsPage";
import LookDetailPage from "@/pages/LookDetailPage";
import ProductDetailPage from "@/pages/ProductDetailPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminReviewQueue from "@/pages/admin/AdminReviewQueue";
import AdminLookReview from "@/pages/admin/AdminLookReview";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminDuplicates from "@/pages/admin/AdminDuplicates";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0B0C]">
        <div className="overline animate-pulse">Authenticating…</div>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={<LookbookPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/looks/:id" element={<LookDetailPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="review" element={<AdminReviewQueue />} />
              <Route path="review/:id" element={<AdminLookReview />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="duplicates" element={<AdminDuplicates />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
